import { AimsCommonPopupEditorData } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { NgPermissionGroups } from 'src/models';

@Component({
  selector: 'app-group-permissions-popup',
  templateUrl: './group-permissions-popup.component.html',
  styleUrls: ['./group-permissions-popup.component.css']
})
export class GroupPermissionsPopupComponent implements OnInit {

  constructor(
    contentData: AimsCommonPopupEditorData,
    public authService: AuthService,
    private transferHttp: TransferHttpService){
      this.isNew = contentData.isNew;
      this.groupToEdit = contentData.contentData as NgPermissionGroups;
      this.formGroup = contentData.formGroup;
      this.formGroup.addControl('permissionGroupName', new FormControl(this.groupToEdit.permissionGroupName, Validators.required))
      this.formGroup.addControl('description', new FormControl(this.groupToEdit.description, Validators.required))
  }
  groupToEdit: NgPermissionGroups;
  isNew: boolean;
  public formGroup: any;

  ngOnInit(): void {
  }

}
